import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";
import toast from "react-hot-toast";

import { AboutUsData } from "../../content.types";
import { requestUpdateAboutUs } from "./updateAboutUs.request";

const useUpdateSocials = (
  options?: MutationOptions<AboutUsData, ApiServiceError<ApiError>>
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: requestUpdateAboutUs,
    onError: toastServerError,
    ...options,
    onSuccess: (data, ...rest) => {
      toast.success("About Us content updated successfully");
      queryClient.setQueryData(["content-about-us"], data);
      options?.onSuccess?.(data, ...rest);
    }
  });
};

export default useUpdateSocials;
